var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a;
import { jsx as _jsx } from "react/jsx-runtime";
import '../../shared/css/generic-styles.css';
import '../../shared/css/Text.css';
import { useViewportSize } from './ProviderResponsive';
import { useThemeable } from './ProviderStyleAccess';
var createTextComponent = function (defaultClass) {
    var Component = function (_a) {
        var _b = _a.width, width = _b === void 0 ? 'fill' : _b, children = _a.children, _c = _a.tag, tag = _c === void 0 ? 'p' : _c, className = _a.className, color = _a.color, weight = _a.weight, style = _a.style, align = _a.align;
        var Tag = tag;
        var combinedStyles = __assign({}, style);
        var spacingMode = useViewportSize().spacingMode;
        var space = useThemeable().space;
        var textStyles = {
            margin: spacingMode === 'normal'
                ? "".concat(space.vExtra, "px ").concat(space.hUnify + space.hExtra, "px")
                : "0px ".concat(space.hUnify, "px"),
        };
        var combinedClasses = [
            'text',
            color ? "color-".concat(color) : '',
            "width-".concat(width),
            defaultClass,
            weight ? "weight-".concat(weight) : '',
            className,
            align === undefined ? '' : "align-".concat(align)
        ]
            .filter(Boolean)
            .join(' ');
        return (_jsx(Tag, { className: combinedClasses, style: __assign(__assign({}, textStyles), combinedStyles), children: children }));
    };
    return Component;
};
// Helper function to generate components with displayName
var components = {
    Title1: 'title1',
    Title2: 'title2',
    Title3: 'title3',
    Headline: 'headline',
    Body: 'body',
    Subhead: 'subhead',
    Footnote: 'footnote',
    Caption1: 'caption1',
    Caption2: 'caption2',
};
export var Title1 = (_a = Object.entries(components).reduce(function (acc, _a) {
    var name = _a[0], className = _a[1];
    var component = createTextComponent(className);
    component.displayName = name;
    acc[name] = component;
    return acc;
}, {}), _a.Title1), Title2 = _a.Title2, Title3 = _a.Title3, Headline = _a.Headline, Body = _a.Body, Subhead = _a.Subhead, Footnote = _a.Footnote, Caption1 = _a.Caption1, Caption2 = _a.Caption2;
